module.exports = __webpack_public_path__ + "static/accessibility-778db323d375f119c8fefe72a635e68c.png";